import { createAction } from '@reduxjs/toolkit';

export const setValidity = createAction<{
  field: FlattenKeys<ValiditiesState>;
  value: any;
}>('SET_VALIDITY');

export const resetValidity = createAction<void>('RESET_VALIDITY');

const ValidityActions = (dispatch: <T>(action: any) => T) =>
  Object.assign(
    {},
    {
      setValidity: <T extends FlattenKeys<ValiditiesState>>(
        field: T,
        value: DeepType<ValiditiesState, T>,
      ) => dispatch<void>(setValidity({ field, value })),
      resetValidity: () => dispatch<void>(resetValidity()),
    },
  );

export default ValidityActions;
